module.exports = __webpack_public_path__ + "uploadPortfoliosHistorical.512f3168785d0892ad1a402c32ecbbcf.svg";